type TextNode = {
  value: string;
};

type ElementNode =
  | {
      type: string;
      value: string;
    }
  | {
      type: string;
      tagName: string;
      properties: {
        href: string;
      };
      children: {
        type: string;
        value: string;
      }[];
    };

export const convertAnchorElement = (
  node: TextNode,
  index: number | undefined,
  parent: { children: ElementNode[] },
) => {
  if (index === undefined) {
    return;
  }

  const urlRegex =
    /(http[s]?:\/\/[^\s]+\.[^\s]+|mailto:[^\s@]+@[^\s@]+\.[^\s@]+)/g;
  let match;
  const parts = [];
  let lastEnd = 0;

  while ((match = urlRegex.exec(node.value)) !== null) {
    const start = match.index;
    const end = urlRegex.lastIndex;
    if (start > lastEnd) {
      parts.push({ type: "text", value: node.value.slice(lastEnd, start) });
    }
    parts.push({
      type: "element",
      tagName: "a",
      properties: { href: match[0] },
      children: [{ type: "text", value: match[0] }],
    });
    lastEnd = end;
  }
  if (lastEnd < node.value.length) {
    parts.push({ type: "text", value: node.value.slice(lastEnd) });
  }

  if (parts.length > 0) {
    parent.children.splice(index, 1, ...parts);
  }
};
